import { UseFormReturn } from 'react-hook-form';
import { FormSwitchInput } from '../../../../../../common/components/masked_inputs/react_forms/form_switch_input';
import { CargoForm } from '../../../schemas/Cargos_cadastro/cargo';

import DefaultFormInput from '../../../../../../common/components/default_form_input';

/**
 * TabInformacoesGerais
 */

type Props = {
  saving: boolean,
  reactHookForm: UseFormReturn<CargoForm>
};

export const TabInformacoesGerais = ({
  saving,
  reactHookForm,
}: Props) => {
  return (
    <>
      <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row items-center gap-2'>
            <FormSwitchInput
              name='ativo'
              readOnly={saving}
              reactHookForm={reactHookForm}
            />
          </div>

          <DefaultFormInput
            name='descricao'
            label='Nome'
            readOnly={saving}
            required={true}
            labelSize='large'
            reactHookForm={reactHookForm}
          />

          <DefaultFormInput
            name='atribuicoes'
            label='Atribuições, responsabilidades e autoridades'
            readOnly={saving}
            required={true}
            multiline={true}
            rows={5}
            labelSize='large'
            reactHookForm={reactHookForm}
          />

          <DefaultFormInput
            name='escolaridade'
            label='Escolaridade'
            readOnly={saving}
            multiline={true}
            rows={4}
            labelSize='large'
            reactHookForm={reactHookForm}
          />

          <DefaultFormInput
            name='experiencia'
            label='Experiência'
            readOnly={saving}
            multiline={true}
            rows={4}
            labelSize='large'
            reactHookForm={reactHookForm}
          />

          <DefaultFormInput
            name='qualificacoes'
            label='Qualificações, conhecimentos e habilitações'
            readOnly={saving}
            multiline={true}
            rows={8}
            labelSize='large'
            reactHookForm={reactHookForm}
          />
        </div>
      </div>
    </>
  );
}